export default (that) => [
  {
    exportName: that.$l('INDEX.btn_export_shippingdetails') || '导出 出运明细',
    templateGroup: 'shipment-shippingdetails',
    exportCheckUrl: '/factory/shipmentInfo/shipmentBatchDetails/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_packinglist') || '导出 Packing List',
    templateGroup: 'shipment-invpk',
    exportCheckUrl: '/factory/shipmentInfo/shipmentInvPk/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_bookingorder') || '导出 托书',
    templateGroup: 'shipment-bookingorder',
    exportCheckUrl: '/factory/shipmentInfo/exportBookingOrderCheck',
  },
  {
    exportName: that.$l('INDEX.btn_export_mcert') || '导出 M-CERT',
    templateGroup: 'shipment-mcert',
    exportCheckUrl: '',
  },
  {
    exportName: that.$l('INDEX.btn_export_inbounddetailsbook') || '导出 入库明细书',
    templateGroup: 'shipment-inbounddetailsbook',
    exportCheckUrl: '/factory/shipmentInfo/exportInboundDetailsBookCheck',
  },
]
